export * from "./model/cardToDelete.store";
